export const formatNumberWithCommas = (value: number | string, isCurrency: boolean = false): string => {
  const parsedNum = typeof value === 'string' ? parseFloat(value) : value;
  
  if (isNaN(parsedNum)) return isCurrency ? "0.00" : "0";

  if (isCurrency) {
    return parsedNum.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  } else {
    return parsedNum.toLocaleString('en-US');
  }
};